import { computed, observable } from "mobx";
import type Month from "../entities/month";
import type EdazLivingMonthsRepository from "../repositories/edazLivingMonthsRepository";

export default class MonthOptionService {
  @observable private sourceMonths: Month[];
  @observable private sourceMonthOptions: string[];

  @computed
  get monthOptions() {
    return this.sourceMonthOptions.map(monthOption => ({ id: monthOption, label: monthOption }));
  }

  constructor(private repository: EdazLivingMonthsRepository) {
    this.initialize();
  }

  private initialize() {
    this.sourceMonths = this.repository.createMonths(true);

    this.sourceMonthOptions = [];

    this.sourceMonths.forEach(month => {
      this.sourceMonthOptions.push(this.formatMonthOption(month.month, month.year));
    });
  }

  // Example: 2022-06
  private formatMonthOption(month: number, year: number) {
    return `${year}-${String(month).padStart(2, "0")}`;
  }
}
